import {
  ChatActionType,
  IChatAttachment,
  IChatAttachmentAction,
  IChatDeleteAction,
  IChatEditAction,
  IChatErrorAction,
  IChatImageAction,
  IChatMessageAction,
} from '@engoo/realtime-protocol/chat';
import { StreamPosition } from '@engoo/realtime-protocol/persisted';

export interface IImageUploadOptions {
  attachment?: IChatAttachment;
  error?: string;
}

export const sendMessage = (contents: string): IChatMessageAction => ({
  type: ChatActionType.Message, contents,
});

export const startImageUpload = ({ error, attachment }: IImageUploadOptions = {}): IChatImageAction => ({
  // Allow optional error for cases like image file too big, or wrong mime type
  // where we can just display error immediately instead of appending it later
  type: ChatActionType.Image, error, attachment,
});

export const setMessageAttachment = (position: StreamPosition, attachment: IChatAttachment): IChatAttachmentAction => ({
  type: ChatActionType.Attachment, message_id: position, attachment,
});

export const setMessageError = (position: number, error: string): IChatErrorAction => ({
  type: ChatActionType.Error, message_id: position, error,
});

export const editMessage = ({
  position,
  contents,
}: {
  position: StreamPosition,
  contents: string,
}): IChatEditAction => ({
  type: ChatActionType.Edit,
  message_id: position,
  contents,
});

export const deleteMessage = ({ position }: { position: StreamPosition }): IChatDeleteAction => ({
  type: ChatActionType.Delete,
  message_id: position,
});
